import * as React from 'react';

export class Loading extends React.Component<{}, {
    showMessage: boolean;
}> {
    state = { showMessage: false };

    showMessageTimer: number | null = null;

    componentDidMount() {
        this.showMessageTimer = window.setTimeout(() => {
            this.showMessageTimer = null;
            this.setState({ showMessage: true });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.showMessageTimer != null) {
            window.clearTimeout(this.showMessageTimer);
            this.showMessageTimer = null;
        }
    }

    render() {
        return this.state.showMessage ? <>Loading...</> : null;
    }
}
